import { useContext } from "react"
import _ from "lodash"
import { Button } from "primereact/button"

// Context
import { FormContext } from "../../context/formContext"

import styles from "../../styles/Form-Btn-Submit.module.css"

export default function FormSubmitBtn() {
  const form = useContext(FormContext)

  const handleEnableSubmit = () => {
    if (form.editMode) {
      let completedBlocks = _.keys(_.pickBy(form.blocksSaved))

      if (_.difference(form.blocksRequired, completedBlocks).length === 0) {
        return true
      }
      return false
    }

    const requiredBlockSavedList = _.map(
      form.blocksRequired,
      (block) => form.blocksSaved[block]
    )

    return _.every(requiredBlockSavedList)
  }

  const enableSubmit = handleEnableSubmit()

  return (
    <Button
      className={styles.submit}
      disabled={!enableSubmit}
      onClick={() => form.handleSubmit()}
    >
      Submit
    </Button>
  )
}
